export const SiteColors = {
    primary: 'white',           // bg gradiants
    secondary: '#ED4F3C',       // footer
    textPrimary: '#FFFFFF',     // heading herosection
    textSecondary: '#1A1A1A',   // other headings
    buttonPrimary: '#60D08E',   // buttons
};

export const CardColors = {
    primary: 'linear-gradient(0deg, rgba(238,148,58,0.7777485994397759) 7%, rgba(237,70,47,0.861782212885154) 98%)',  // cart gradiant bg
    secondary: '#F07130',       // cart bg 2
    textPrimary: '#ED462F',     // price color
    textSecondary: '#047AFB',   // other texts
    buttonPrimary: '#60D08E',   // checkout
    buttonSecondary: '#6C757D', // Clear Cart
};
